import _ from 'lodash';

import * as types from './types';

const INITIAL_STATE = {
  applicationData: [],
  studentData: [],
  fetchingApplications: false,
  fetchingStudents: false,
  fetchError: null,
  selectedConfidence: 0,
  selectedSystemId: null,
  selectedHHId: null,
  selectedStudentIdSeeds: [],
  savedSuccessfully: false,
  noStudentsFound: false,
  isHistoryShown: false,
  alteredApplications: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.FAMILY_MATCH_GET_APPLICATIONS_AND_STUDENTS:
      const appDataWithCheckbox1 = payload.ApplicationList.map(obj => ({
        ...obj,
        Selected: false,
      }));

      const stuDataWithCheckbox1 = payload.StudentList.map(obj => ({
        ...obj,
        Selected: false,
      }));

      return {
        ...state,
        applicationData: appDataWithCheckbox1,
        studentData: stuDataWithCheckbox1,
      };

    case types.FAMILY_MATCH_WRITE_APPLICATION_WITH_MATCHED_STUDENT:
      return {
        ...state,
        studentData: [],
        selectedStudentIdSeeds: [],
        savedSuccessfully: true,
      };
    case types.FAMILY_MATCH_SET_ERROR:
      return {
        ...state,
        fetchError: payload,
      };
    case types.FAMILY_MATCH_SET_FETCHING_APPLICATIONS:
      return {
        ...state,
        fetchingApplications: payload,
      };
    case types.FAMILY_MATCH_SET_FETCHING_STUDENTS:
      return {
        ...state,
        fetchingStudents: payload,
      };
    case types.FAMILY_MATCH_SET_SYSTEMID_AND_HHID:
      return {
        ...state,
        selectedSystemId: payload.SystemId,
        selectedHHId: payload.HHId,
      };
    case types.FAMILY_MATCH_ADD_STUDENT_ID_SEED:
      return {
        ...state,
        selectedStudentIdSeeds: [...state.selectedStudentIdSeeds, payload],
      };
    case types.FAMILY_MATCH_REMOVE_STUDENT_ID_SEED:
      return {
        ...state,
        selectedStudentIdSeeds: state.selectedStudentIdSeeds.filter(
          x => x !== payload
        ),
      };
    case types.FAMILY_MATCH_SET_CONFIDENCE:
      return {
        ...state,
        selectedConfidence: payload,
      };
    case types.FAMILY_MATCH_SET_SUCCESS_FLAG:
      return {
        ...state,
        savedSuccessfully: payload,
      };
    case types.FAMILY_MATCH_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: '',
      };
    case types.FAMILY_MATCH_SET_NO_STUDENT_FLAG:
      return {
        ...state,
        noStudentsFound: payload,
      };
    case types.FAMILY_MATCH_CHECK_APPLICATION_GRID:
      const appStateCopy = _.cloneDeep(state);
      const { applicationData } = appStateCopy;
      const foundApp = applicationData.find(
        row => row.SystemId === payload.row.SystemId
      );

      applicationData.forEach(e => {
        e.Selected = false;
      });

      const appIndex = applicationData.indexOf(foundApp);

      applicationData[appIndex].Selected = payload.shouldCheck;
      return {
        ...state,
        applicationData,
      };

    case types.FAMILY_MATCH_CHECK_STUDENT_GRID:
      const studentStateCopy = _.cloneDeep(state);
      const { studentData } = studentStateCopy;
      const foundStudent = studentData.find(
        row => row.IdSeed === payload.row.IdSeed
      );
      studentData.forEach(e => {
        if (!state.selectedStudentIdSeeds.includes(e.IdSeed)) {
          e.Selected = false;
        }
      });

      const studentIndex = studentData.indexOf(foundStudent);

      studentData[studentIndex].Selected = payload.shouldCheck;
      return {
        ...state,
        studentData,
      };

    case types.FAMILY_MATCH_CLEAR_SELECTED_STUDENTS:
      return {
        ...state,
        selectedStudentIdSeeds: [],
      };

    case types.FAMILY_MATCH_TOGGLE_HISTORY:
      return {
        ...state,
        isHistoryShown: payload,
      };

    case types.FAMILY_MATCH_ADD_TO_HISTORY:
      return {
        ...state,
        alteredApplications: [...state.alteredApplications, payload],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/familymatchutility/state/reducer.js